export const categories = [
  {
    key: "伦理",
    label: "伦理",
    en: "Ethics",
    icon: "ri-heart-3-line",
    tagline: "关系、边界与选择的困局",
    intro:
      "聚焦婚姻、家庭与亲密关系中的灰色地带。这里的作品不急于审判人物，而是把选择的重量交回给观众，偏爱克制的镜头与留白的叙事。",
    aliases: ["伦理", "道德困境", "关系"],
  },
  {
    key: "剧情",
    label: "剧情",
    en: "Drama",
    icon: "ri-film-line",
    tagline: "以人物为轴心的长篇叙事",
    intro:
      "以人物和时间为轴心，讲述普通人在生活褶皱里的挣扎与和解。节奏偏慢，情绪饱满，适合想看完整故事而非刺激镜头的观众。",
    aliases: ["剧情", "故事", "人物"],
  },
  {
    key: "情色",
    label: "情色",
    en: "Erotic",
    icon: "ri-moon-clear-line",
    tagline: "欲望作为叙事语言的成人作品",
    intro:
      "以欲望与身体为叙事语言的成人向作品。收录皆为剧情驱动的影片，情欲服务于人物处境，注重氛围、光影与情绪的铺陈。",
    aliases: ["情色", "成人向", "欲望"],
  },
  {
    key: "经典",
    label: "经典",
    en: "Classic",
    icon: "ri-video-on-line",
    tagline: "值得反复回看的旧作修复",
    intro:
      "被时间验证过的老片与修复版。无论是九十年代的城市寓言，还是平成初年的家庭剧，这些作品的质感与余韵至今没有褪色。",
    aliases: ["经典", "老片", "修复"],
  },
];

export const filterYears = [
  { label: "全部年份", value: "all" },
  { label: "2025", value: "2025" },
  { label: "2024", value: "2024" },
  { label: "2023", value: "2023" },
  { label: "2022", value: "2022" },
  { label: "2021 及更早", value: "earlier" },
];

export const filterRegions = [
  { label: "全部地区", value: "all" },
  { label: "日本", value: "日本" },
  { label: "韩国", value: "韩国" },
];

export const filterRatings = [
  { label: "全部评分", value: "all" },
  { label: "8.5 分以上", value: "8.5" },
  { label: "8.0 分以上", value: "8.0" },
  { label: "7.5 分以上", value: "7.5" },
];

export const sortOptions = [
  { label: "最新上架", value: "latest" },
  { label: "热门优先", value: "popular" },
  { label: "评分最高", value: "rating" },
];